// Display formatting helpers.

// Global display currency, set once from settings at app startup. Kept as a
// module-level value so every formatCurrency call picks it up without threading
// the currency through each call site.
let globalCurrency = 'NGN'

const LOCALE_BY_CURRENCY = {
  NGN: 'en-NG',
  USD: 'en-US',
  EUR: 'de-DE',
  GBP: 'en-GB',
  GHS: 'en-GH',
  KES: 'en-KE',
  ZAR: 'en-ZA'
}

export function setGlobalCurrency(code) {
  if (code) globalCurrency = code
}

export function formatCurrency(amount, currency = globalCurrency, locale) {
  const value = Number(amount) || 0
  const resolvedLocale = locale || LOCALE_BY_CURRENCY[currency] || 'en'
  return new Intl.NumberFormat(resolvedLocale, {
    style: 'currency',
    currency
  }).format(value)
}

// Compact currency for tight spaces like chart axes (e.g. ₦2.7M, ₦350K).
export function formatCompactCurrency(amount, currency = globalCurrency, locale) {
  const value = Number(amount) || 0
  const resolvedLocale = locale || LOCALE_BY_CURRENCY[currency] || 'en'
  return new Intl.NumberFormat(resolvedLocale, {
    style: 'currency',
    currency,
    notation: 'compact',
    maximumFractionDigits: 1
  }).format(value)
}

// Compact plain number for chart axes (e.g. 2.7M, 350K).
export function formatCompactNumber(amount, locale = 'en') {
  const value = Number(amount) || 0
  return new Intl.NumberFormat(locale, {
    notation: 'compact',
    maximumFractionDigits: 1
  }).format(value)
}

export function formatDate(value, locale = 'en-NG') {
  if (!value) return ''
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'short',
    day: '2-digit'
  }).format(date)
}

export function formatDateTime(value, locale = 'en-NG') {
  if (!value) return ''
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date)
}

export function titleCase(value) {
  if (!value) return ''
  return String(value)
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase())
}
